var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25714 2.77716V0H8.22857V2.77716H0V3.80573H1.02857V10.4779C1.02857 12.1564 2.43851 13.5297 4.16176 13.5297H5.54977L3.08571 17.8418L3.97876 18.3521L6.73443 13.5297H11.0115L13.7672 18.3521L14.6602 17.8418L12.1961 13.5297H13.5613C15.2846 13.5297 16.6945 12.1564 16.6945 10.4779V3.80573H18V2.77716H9.25714ZM15.6659 3.87692H2.05714V10.4779C2.05714 11.5629 2.98088 12.5011 4.16176 12.5011H13.5613C14.7422 12.5011 15.6659 11.5629 15.6659 10.4779V3.87692Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.bae4295970449ed5c365774df4860e79.svg";
export { ForwardRef as ReactComponent };